import { FC } from 'react';
import { Box, Modal as QcsModal } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { QcsProtocolIframe, QcsProtocolImg, QcsProtocolModalBox } from '../layout/QcsProtocolStyles';
import { QcsFloatingPillButton } from './basic/QcsFloatingPillButton';

interface Props {
  iframeSrc: string;
  contentType: string;
  onClose: () => void;
  onDownload: () => void;
}

export const DocumentPreviewModal: FC<Props> = ({ iframeSrc, contentType, onClose, onDownload }) => {
  return (
    <QcsModal open={!!iframeSrc} onClose={onClose} disableEscapeKeyDown={false}>
      <QcsProtocolModalBox disableBorder={true}>
        <Box
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            gap: 1,
            zIndex: 1,
          }}
        >
          <QcsFloatingPillButton icon={<CloseIcon />} labelKey="common.close" onClick={onClose} />
          <QcsFloatingPillButton icon={<CloudDownloadIcon />} labelKey="common.download" onClick={onDownload} />
        </Box>
        {iframeSrc &&
          (contentType?.startsWith('image/') ? (
            <Box
              sx={{
                backgroundColor: 'white',
                display: 'inline-block',
                lineHeight: 0,
              }}
            >
              <QcsProtocolImg src={iframeSrc} alt="Document" />
            </Box>
          ) : (
            <QcsProtocolIframe
              src={iframeSrc}
              style={{ border: 0 }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ))}
      </QcsProtocolModalBox>
    </QcsModal>
  );
};
